<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-power-switch`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 4a1 1 0 011 1v37a2 2 0 01-2 2H6a2 2 0 01-2-2V5a1 1 0 011-1h38zm-3 4H8v32h32V8zm-3 4a1 1 0 00-1-1H12a1 1 0 00-1 1v23a2 2 0 002 2h22a2 2 0 002-2V12zm-3.5 2.5h-19v19h19v-19zM30 18a1 1 0 00-1-1H19a1 1 0 00-1 1v1.5a1 1 0 001 1h10a1 1 0 001-1V18z"/></svg>
</template>
<script>

export default {
  name: 'IconPowerSwitch',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
